export default __webpack_public_path__ + "static/media/EZ_LEISURE_LOGO.77316c35.svg";